/* [PATCH nastavitve-zavihki v1] preseljeno 1:1 iz ProfilPage.tsx:
   smer='prejeti'  -> blok 365-381 ([PATCH placano-profil-fe v1])
   smer='izdani'   -> blok 383-399 ([PATCH placano-izdani-profil-fe v1])
   Polja, konti in besedila nespremenjena; spremenjen je samo ovoj kartice. */
import React from 'react';
import { Wallet } from 'lucide-react';
import { KontoInput } from '../KontoInput';
import { PlacnikPartnerVnos } from '../PlacnikPartnerVnos';

export function RacunPlacanKartica({ smer, data, set, companyId }: {
  smer: 'prejeti' | 'izdani';
  data: any;
  set: (field: string, value: any) => void;
  companyId: string;
}) {
  const jePrejeti = smer === 'prejeti';
  const polje = jePrejeti ? 'placnik_delavec' : 'placnik_delavec_izdani';
  const vrednost = data?.[polje] || {};
  const naslov = jePrejeti ? 'Račun = plačan — prejeti računi' : 'Račun = plačan — izdani računi';
  const opis = jePrejeti
    ? 'Gumb "+ Plačano" na prejetih računih prenese obveznost z dobavitelja na spodnji konto in izbranega plačnika (delavca, ki je račun plačal z gotovino).'
    : 'Gumb "+ Plačano" na izdanih računih prenese terjatev s kupca na spodnji konto in izbranega prejemnika (delavca, ki je gotovino prejel).';
  const oznakaOsebe = jePrejeti ? 'Privzeti plačnik (delavec)' : 'Privzeti prejemnik (delavec)';
  const placeholderKonto = jePrejeti ? '285000' : '9190';

  return (
    <div className="rounded-2xl border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 p-5">
      <div className="flex items-center gap-3">
        <div className="w-9 h-9 rounded-xl bg-blue-50 dark:bg-blue-900/30 text-blue-600 flex items-center justify-center">
          <Wallet className="w-5 h-5" />
        </div>
        <div>
          <h2 className="font-semibold text-gray-900 dark:text-white">{naslov}</h2>
          <p className="text-xs text-gray-500">{opis}</p>
        </div>
      </div>
      <div className="mt-4 grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div>
          <label className="block text-xs font-medium text-gray-500 dark:text-gray-400 mb-1">Konto (iz kontnega plana)</label>
          <KontoInput value={vrednost.konto || ''} placeholder={placeholderKonto}
            onChange={(konto, naziv) => set(polje, { ...vrednost, konto, konto_naziv: naziv || '' })} />
        </div>
        <div>
          <label className="block text-xs font-medium text-gray-500 dark:text-gray-400 mb-1">{oznakaOsebe}</label>
          <PlacnikPartnerVnos companyId={companyId}
            partnerId={vrednost.partner_id} partnerNaziv={vrednost.partner_naziv}
            onIzbira={(partner_id, partner_naziv) => set(polje, { ...vrednost, partner_id, partner_naziv })} />
        </div>
      </div>
    </div>
  );
}
